module.exports = __webpack_public_path__ + "img/logo_adveroo.8ff07030.svg";